export default __webpack_public_path__ + "static/7-81bb099270e5bc237da31d5f740bb90c.svg";